import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSubversionComponent } from './simple-icons-subversion.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSubversionComponent ],
    exports:      [ SimpleIconsSubversionComponent ],
    bootstrap:    []
})
export class SimpleIconsSubversionModule {}
